import React from 'react';

const FileDownloadService = {
  b64toBlob(b64Data, contentType = '') {
    const sliceSize = 512;
    const cleanedData = b64Data.replace(/^[^,]+,/, '').replace(/\s/g, '');
    const byteCharacters = window.atob(cleanedData);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = Array.from(slice, char => char.charCodeAt(0));
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
  },

  getMimeType(extension) {
    const mimeTypes = {
      xml: 'text/plain;charset=utf-8',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      pdf: 'application/pdf',
      txt: 'text/plain;charset=utf-8',
      json: 'application/json',
    };
    return mimeTypes[extension] || 'application/octet-stream';
  },

  downloadFile(data, fileName, extension) {
    const mimeType = this.getMimeType(extension);
    const blob = this.b64toBlob(data, mimeType);
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.${extension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },
};

export default FileDownloadService;